import { Geometry } from 'geojson';

import { Pipe, PipeTransform } from '@angular/core';

import { LocaleService, t } from '@lib/translation';

@Pipe({
  name: 'geometryToString',
})
export class SnGeometryToStringPipe implements PipeTransform {
  constructor(private readonly _localeService: LocaleService) {}

  public transform(value: Geometry): string {
    if (value && value.type === 'Point') {
      const lat = value.coordinates[1];
      const lon = value.coordinates[0];

      const formattedLat = this._localeService.formatCoordinate(lat);
      const formattedLon = this._localeService.formatCoordinate(lon);

      return t('common.coordinateFormat', {
        lat: formattedLat,
        lon: formattedLon
      });
    }

    return '';
  }
}
